<template>
  <div class="alarm-subtitle">
    <div class="d-flex justify-content-end">
      <b-button
        class="alarm-subtitle__button mt-1 mt-lg-0"
        size="sm"
        variant="outline-secondary"
        @click="toggleSubtitleModal"
      >
      <span class="material-icons-round">
        bookmark_border
      </span>
        {{ $t('general.subtitle') }}
      </b-button>
    </div>

    <s-modal
      v-model="showModal"
      class="alarm-subtitle__modal"
      ok-only
      :ok-title="$t('actions.close')"
      :title="$t('general.subtitle')"
      @ok="toggleSubtitleModal"
    >
      <s-table
        class="alarm-subtitle__modal-table-overflow alarm-subtitle__modal-table"
        sticky-header
        :fields="fields"
        :items="terms"
      >
        <template #cell(term)="{ item }">
          <classification
            v-if="item.isClassification"
            :classification="item.term"
            :show-label="true"
          />
          <icon-badge
            v-else
            icon-class="fas fa-bell"
            badge-icon-class="fas fa-check"
            badge-color="var(--color-info)"
            :icon-color="getAlarmIconColor(item)"
            :show-badge="item.recognized"
          />
        </template>
        <template #cell(description)="{ item }">
          {{ $t(item.description) }}
        </template>
      </s-table>
    </s-modal>
  </div>
</template>

<script>
import IconBadge from '@/components/icon/IconBadge';
import Classification from '@/components/Classification';
import TermsAndDescription from '@/domain/data/generalPanel/alarmsAndWarnings/terms-and-description.json';

export default {
  name: 'AlarmSubtitleModal',
  components: {
    Classification,
    IconBadge,
  },
  data: () => ({
    showModal: false,
    terms: TermsAndDescription,
  }),
  computed: {
    fields() {
      return [
        {
          key: 'term',
          label: this.$t('general.icon'),
          tdClass: 'alarm-subtitle__modal-table-td-term',
          thClass: 'alarm-subtitle__modal-table-th-term',
        },
        {
          key: 'description',
          label: this.$t('general.description'),
          thClass: 'alarm-subtitle__modal-table-th-description',
          tdClass: 'alarm-subtitle__modal-table-td-description',
        },
      ];
    },
  },
  methods: {
    toggleSubtitleModal() {
      this.showModal = !this.showModal;
    },
    getAlarmIconColor(item) {
      return !item.acted ? 'var(--font-color-primary)' : 'var(--color-secondary)';
    },
  },
};
</script>

<style lang="sass">
.alarm-subtitle
  padding-right: 40px
  padding-left: 40px

  &__button
    & span.material-icons-round
      font-size: 1.2rem
      vertical-align: bottom

  &__modal-table
    border: 1px solid var(--color-border-regular)
    box-sizing: border-box
    border-radius: 5px

    &-th-term,
    &-th-description
      background: var(--color-table-header-bg) !important

    &-th-term,
    &-td-term
      border-right: 2px solid #FFF
      text-align: center !important

      & > span
        display: inline-block
        vertical-align: middle

        & .classification
          margin-right: 0

    &-td-description,
    &-th-description
      text-align: left !important

  &__modal-table-overflow
    max-height: 38vh
    overflow-x: hidden
    overflow-y: auto

</style>
